export default __webpack_public_path__ + "static/media/TriangleRed.09faa954.svg";